import React, { useEffect, useState } from "react";
import pick2 from "../../../Assets/Icons/pick_2.png";
import MediaPicker from "../mediaPicker";
import { callInfluencer } from "../../callApi/home";
import config from "../../Config.json";
import { fileUpload } from "../../../fileUpload";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../Redux/action";
import toast from "react-hot-toast";
import IsActive from "../AdminisActive";

const Influencer = () => {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;
  const dispatch = useDispatch();

  const [data, setData] = useState({
    AdminId: AdminId,
    ShowInWebSite: "",
    heading: "",
    item: [
      {
        title: "",
        image: { image: "", file: "", status: "none" },
      },
    ],
  });

  const _data = data;
  const [option, setOption] = useState(false);

  // update data state
  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  // check if any field is empty
  const isEmpty = () => {
    let res = false;
    data.item.forEach((item) => {
      if (item.title && item.image) {
        res = true;
      } else {
        res = false;
      }
    });
    return res;
  };

  // save function
  const handleSave = async () => {
    dispatch(setLoading(true));
    let isValidate = isEmpty();
    if (isValidate) {
      let updatedImages = data.item.reduce((accumulator, item) => {
        if (item.image.status === "updated" && item.image.file != null) {
          return accumulator.concat(item.image);
        }
        return accumulator;
      }, []);

      let media = [];

      if (updatedImages.length > 0) {
        fileUpload(updatedImages).then((uploadImageRes) => {
          if (uploadImageRes?.length > 0) {
            media = data.item.map((x) => {
              if (x?.image?.status === "updated") {
                return uploadImageRes.filter(
                  (y) => y.fileName == x.image.file.name
                )[0]?.key;
              } else {
                return x.image.image;
              }
            });
            saveData(media);
          }
        });
      } else {
        media = data.item.map((x) => x.image.image);
        saveData(media);
      }
    } else {
      dispatch(setLoading(false));
      toast.error("Please fill all values");
    }
  };

  const saveData = (media) => {
    const params = {
      media: media,
      AdminId: AdminId,
      heading: data.heading,
      item: data.item.map((item) => {
        return { title: item.title };
      }),

      ShowInWebSite: option ? 1 : 0,
    };

    callInfluencer(params).then((res) => {
      if (res) {
        dispatch(setLoading(false));
        toast.success("Data saved successfully");
      } else {
        dispatch(setLoading(false));
        toast.error("Something went wrong");
      }
    });
  };

  useEffect(() => {
    const influencerCollabData = JSON.parse(
      sessionStorage.getItem("homeApi")
    ).InfluencerCollab;
    const { heading, content, media, ShowInWebSite } = influencerCollabData;

    _data.heading = heading;
    content.forEach((item, index) => {
      _data.item[index] = {
        title: item.title,
        image: { image: media[index] },
        imageName: config.awsMediaPath + media[index],
      };
    });
    setOption(ShowInWebSite == 1 ? true : false);

    updateData();
  }, []);

  return (
    <div className="section-d section-h sec">
      <h2>Influencer Collab</h2>

      <div className="input-container">
        <label for="influencer-title">Heading</label>
        <input
          id="influencer-title"
          type="text"
          className="validate heading-input"
          maxLength={60}
          placeholder="heading"
          onChange={(e) => {
            const { value } = e.target;
            const _data = data;
            _data.heading = value;
            updateData();
          }}
          value={data.heading}
        />
      </div>
      {/* add button */}
      <button
        className="add-button"
        onClick={() => {
          _data.item.push({
            name: "",
            review: "",
            date: "",
            image: { image: "", file: "", status: "none" },
          });
          updateData();
        }}
      >
        Add +{" "}
      </button>

      <div className="collab-container">
        {data.item.map((item, index) => (
          <div className="collab-card">
            {/* add photo */}
            <MediaPicker
              type="image"
              source={item.imageName}
              onChange={(file, image) => {
                _data.item[index].image.file = file;
                _data.item[index].image.image = image;
                _data.item[index].imageName = image;
                _data.item[index].image.status = "updated";
                updateData();
              }}
            />
            {/* add instagram link */}
            <div className="influencer-input-field">
              <label htmlFor={"influencer-card-title" + index}>
                Add Instagram Link
              </label>
              <input
                id={"influencer-card-title" + index}
                type="text"
                className="validate ig-link"
                onChange={(text) => {
                  text = text.currentTarget.value;
                  _data.item[index].title = text;
                  updateData();
                }}
                value={item.title}
              />
            </div>
            {/* remove button */}
            <button
              className="remove-card-button width100"
              onClick={() => {
                const newArray = _data.item.filter(
                  (item) => _data.item.indexOf(item) !== index
                );
                _data.item = newArray;
                updateData();
              }}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      <div className="input-field">
        <label>
          <IsActive checked={option} onChange={() => setOption(!option)} />
        </label>
      </div>

      <button className="btn save" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

export default Influencer;
